
import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';

function MultipleItemComponent(props) {
  const { section, children } = props;
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!section || !section.fields || !section.fields.items) {
      setEntries([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Fetch all items in parallel using Amplify API
    const fetchEntries = async () => {
      try {
        const promises = section.fields.items.map(item =>
          API.get('content', '/content', { queryStringParameters: { 'sys.id': item.sys.id } })
        );
        const results = await Promise.all(promises);
        // Extract first item from each result
        const fetchedEntries = results.map(result =>
          result && result.items && result.items.length > 0 ? result.items[0] : null
        );
        setEntries(fetchedEntries);
        setLoading(false);
      } catch (err) {
        setError(err);
        setEntries([]);
        setLoading(false);
      }
    };

    fetchEntries();
  }, [section]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading items.</div>;
  if (!entries || entries.length === 0) return null;

  // Render children as a function, passing entries, loading, error
  return typeof children === 'function'
    ? children({ entries, loading, error })
    : null;
}

export default MultipleItemComponent;
